export default __webpack_public_path__ + "static/tek_img_10-708f20efd80ba97fad4445e4566ab4e5.webp";